import { TriangleAlert } from "lucide-react";

import style from "./NonIrishCountryNotice.module.css";

// Blocking notice: CDM/OCF/PP are Irish PCRS programmes, so a patient whose
// country is set to something other than Ireland is not eligible. Reviews cannot
// be started or edited while this is shown (see isNonIrishForCdm).
export const NonIrishCountryNotice = () => {
  return (
    <div className={style.notice} role="alert">
      <TriangleAlert size={20} className={style.icon} />
      <p className={style.text}>
        This patient&apos;s country is not set to Ireland. CDM, Opportunistic Case
        Finding and Prevention Programme are only available to patients resident
        in Ireland — update the patient&apos;s country to continue.
      </p>
    </div>
  );
};
